<template>
	<div>
		<page-title :name="pageName" :title="pageTitle" :breadcrumbs="pageBreadcrumbs" />
		<page-content :content="pageContent" />
	</div>
</template>

<script>
import PageContent from '@/components/partials/PageContent'
import PageInfo from '@/mixins/PageInfo'
import PageTitle from '@/components/partials/PageTitle'

export default {
	name: 'FaqLawyer',
	components: {
		PageContent,
		PageTitle,
	},
	mixins: [PageInfo],
}
</script>



// WEBPACK FOOTER //
// src/views/service/FaqLawyer.vue